import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  &:empty {
    height: 0px;
  }
  .icon.check {
    opacity: 0;
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  .cssDropdownItemSubtext {
    opacity: 0.8;
    font-size: ${pxToRem(12)};
    font-weight: 400;
    margin-left: ${pxToRem(5)};
  }
  &[data-has-icon='true'] ${IconContainer} {
    width: ${pxToRem(30)};
  }
  [aria-checked='false'] & {
    &[data-has-icon='true'].cssCheckSelected ${IconContainer} {
      visibility: hidden;
    }
  }
  div:not([aria-checked]) & {
    &[data-has-icon='true'].cssCheckSelected ${IconContainer} {
      display: none;
    }
  }
`;

export const DropdownTextContainer = styled.div<{ $hideText: boolean }>`
  display: ${({ $hideText }) => ($hideText ? 'none' : 'inherit')};
`;

export const StyledSemanticDropdown = styled(SemanticUI.Dropdown)`
  &&&& {
    &.ui.dropdown {
      margin-bottom: unset;
    }
    .cssDropdownDivider {
      &.item.disabled {
        opacity: 1;
        padding: 0 !important;
        margin: ${pxToRem(5)} 0;
        border-top: ${pxToRem(1)} solid #d6d6d6 !important;
        &:hover {
          background: inherit;
        }
      }
      + .item {
        border-top: none !important;
      }
      .cssDropdownSection + & {
        margin-top: 0 !important;
      }
    }
    .cssDropdownHeader {
      &.item.disabled {
        opacity: 1;
        border-top: none;
        color: #616161;
        font-size: ${pxToRem(12)};
        font-weight: bold;
        text-transform: uppercase;
        &:hover {
          background: inherit;
        }
      }
      &.cssDropdownSection {
        &.item.disabled {
          background: #fcfcfc;
          padding: ${pxToRem(5)} ${pxToRem(10)} !important;
        }
      }
    }
  }
`;
